import { Injectable } from '@angular/core';
import { distinctUntilKeyChanged, Observable, Subject } from 'rxjs';
import { filter } from 'rxjs/operators';
import {
  APP_EVENT,
  APP_EVENT_KEY,
  EVENT_KEY,
  EVENT_VALUE,
  JSONValue,
} from '@models';

@Injectable({
  providedIn: 'root',
})
export class EventService {
  #event$: Subject<APP_EVENT> = new Subject<APP_EVENT>();

  public emitEvent(key: APP_EVENT_KEY, value?: JSONValue): void {
    const event: APP_EVENT = value !== undefined ? { key, value } : { key };
    this.#event$.next(event);
  }

  public getEventByKey(key: APP_EVENT_KEY): Observable<APP_EVENT> {
    return this.#event$
      .asObservable()
      .pipe(filter((event: APP_EVENT): boolean => event.key === key));
  }

  public getDistinctEventByKey(key: APP_EVENT_KEY): Observable<APP_EVENT> {
    return this.#event$.asObservable().pipe(
      filter((event: APP_EVENT): boolean => event.key === key),
      distinctUntilKeyChanged(EVENT_KEY)
    );
  }

  public getDistinctEventByKeyValue(key: APP_EVENT_KEY): Observable<APP_EVENT> {
    return this.#event$.asObservable().pipe(
      filter((event: APP_EVENT): boolean => event.key === key),
      distinctUntilKeyChanged(EVENT_VALUE)
    );
  }
}
